import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SContainer, SIcon, SRow } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';

import config from '../../conf';

import { getAuthLogin } from '../../lib/helpers';
import { selectState } from '../../selectors';
import { riskBannerText } from './constants';
import { RiskAssessmentBanner } from './styled/risk-banner';

const RiskAssessmentBannerComponent = () => {
  const {
    account: { isLoggedIn },
    order: { discountCode, discountPercent },
  } = useSelector(selectState);

  const { heading, subHeading1, subHeading2, infoHeading, infoBullet1, infoBullet2, infoBullet3, infoBullet4 } =
    riskBannerText;

  const isDiscounted = discountCode != null && discountPercent === 100;

  return (
    <RiskAssessmentBanner role='complementary'>
      <div className='banner-container'>
        <SContainer>
          <SRow className='pad-all-sm'>
            <SCol center='' span='sm-10 md-8 lg-5 5' className='text-space pad-bottom-md'>
              <div className='text-white banner-header-xl'>{heading}</div>
              <div className='font-light banner-header-sm'>{subHeading1}</div>
              <div className='font-light banner-header-sm pad-bottom-lg'>{subHeading2}</div>
              {!isLoggedIn && (
                <a
                  className='button secondary license-button'
                  href={`${config.CLIENT_URL}${getAuthLogin()}`}
                  aria-label={t('client.accessibility.sign-in-to-your-account')}
                  tabIndex={0}
                  data-ref='returns.login-button'
                >
                  {t('client.general.already-have-an-account-sign-in-to-buy')}
                </a>
              )}
            </SCol>

            <SCol
              className='header-second-col pad-bottom-none'
              center='true'
              span='sm-10 md-10 lg-6 5'
              offset='xl-1 lg-1'
            >
              <div className='pad-all-md banner-header-lg text-center' data-ref='risk-assessment.info-header'>
                {infoHeading}
              </div>
              <div className='license-list pad-bottom-md'>
                <SRow>
                  <SCol span='1' className='checkmark'>
                    <SIcon name='check' />
                  </SCol>
                  <SCol span='xl-11 10' className='checkmark-text'>
                    {infoBullet1}
                  </SCol>
                </SRow>
                <SRow>
                  <SCol span='1' className='checkmark'>
                    <SIcon name='check' />
                  </SCol>
                  <SCol span='xl-11 10' className='checkmark-text'>
                    {infoBullet2}
                  </SCol>
                </SRow>
                <SRow>
                  <SCol span='1' className='checkmark'>
                    <SIcon name='check' />
                  </SCol>
                  <SCol span='xl-11 10' className='checkmark-text'>
                    {infoBullet3}
                  </SCol>
                </SRow>
                {!isDiscounted && (
                  <SRow>
                    <SCol span='1' className='checkmark'>
                      <SIcon name='check' />
                    </SCol>
                    <SCol span='xl-11 10' className='checkmark-text'>
                      {infoBullet4}
                    </SCol>
                  </SRow>
                )}
              </div>
            </SCol>
          </SRow>
        </SContainer>
      </div>
    </RiskAssessmentBanner>
  );
};

export default RiskAssessmentBannerComponent;
